import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgHomeIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 64 64"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g fill="currentColor">
      <path
        data-color="color-2"
        d="M62 29a1 1 0 0 1-.624-.219L32 5.281l-29.375 23.5a1 1 0 0 1-1.25-1.562l30-24a1 1 0 0 1 1.25 0l30 24A1 1 0 0 1 62 29Z"
      />
      <path d="m32 7.842-23 18.4V58a3 3 0 0 0 3 3h13V45a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v16h13a3 3 0 0 0 3-3V26.242Z" />
    </g>
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgHomeStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgHomeIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const HomeIcon: any = SvgHomeStyle;
export default HomeIcon;
